module.exports = __webpack_public_path__ + "img/inktober_2020_22_chef.7817799e.jpg";